var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "483F1716-C9A1-4D58-BB70-3BA26DBD73A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.500476926
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---360-",
    transform: "translate(-315.000000, -158.000000)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "course-1",
    transform: "translate(296.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "course-done",
    transform: "translate(20.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.995025,5.36993437 C11.7487438,5.11024687 11.33815,5.09880937 11.0780563,5.34571562 L6.9370875,9.27290312 L4.9619625,7.24496562 C4.71180625,6.98830937 4.30165,6.98268437 4.044775,7.23287187 C3.78811875,7.48280937 3.7827125,7.89340312 4.03265,8.15005937 L6.454275,10.6363406 C6.58118125,10.7667156 6.7498375,10.8324344 6.91893125,10.8324344 C7.07936875,10.8324344 7.23980625,10.7731844 7.36543125,10.6544969 L11.9708688,6.28693437 C12.2307125,6.04043437 12.2417438,5.62984062 11.995025,5.36993437",
    id: "Fill-1",
    stroke: "#F88801",
    fill: "#F88801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,14.7027281 C4.30421875,14.7027281 1.29728125,11.6960406 1.29728125,8.00000937 C1.29728125,4.30422812 4.3041875,1.29729062 8,1.29729062 C11.696,1.29729062 14.7027187,4.30419687 14.7027187,8.00000937 C14.7027187,11.6960094 11.696,14.7027281 8,14.7027281 M8,9.375e-06 C3.58875,9.375e-06 0,3.58875937 0,8.00000937 C0,12.4112594 3.58875,16.0000094 8,16.0000094 C12.41125,16.0000094 16,12.4112594 16,8.00000937 C16,3.58875937 12.41125,9.375e-06 8,9.375e-06",
    id: "Fill-3",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseDone);
export default __webpack_public_path__ + "static/media/course-done.9be1b68a.svg";
export { ForwardRef as ReactComponent };